import {useState} from "react";
import getCookie from "../../../partials/cookie";
import ConfirmSMS from './ConfirmSMS';

function VerifyNumber(props) {
    const {staff, confirmed, rhash, setErrors} = props
    const [number, setNumber] = useState(null);

    let csrftoken = getCookie('csrftoken');

    const confirm = (e) => {
        e.preventDefault();
        fetch(`/api/phone_consultation_number_confirm/${rhash}/`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': csrftoken,
            },
            body: JSON.stringify({
                'confirm_nb': number
            })
        }).then(res => {
            if (res.ok) {
                res.json().then(
                    window.location.replace(`/bezplatna-konsultacja-telefoniczna/potwierdzono/${rhash}`))
            } else {
                res.json().then(
                    data=>setErrors(data.confirm_nb))
            }
        })
    }

    if(confirmed || staff === true)
    return(
    <div className="confirm-sms">
        <form onSubmit={confirm}>
            <ConfirmSMS staff={staff} number={number} setNumber={setNumber}/>
            <div></div>
            <button type="submit" className="btn btn-success">Potwierdź i rozpocznij</button>
        </form>
    </div>
    )
}

export default VerifyNumber;